import { render } from "./FooterBar.vue?vue&type=template&id=6e4386bd&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=6e4386bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4386bd"]])

export default __exports__